import { trans } from "@mongez/localization";

/**
 * Impact messages component
 */
export function ImpactMessages() {
  return (
    <div className="space-y-2 sm:space-y-3 md:space-y-4 lg:space-y-3 xl:space-y-4">
      <p className="text-lg leading-relaxed text-marine sm:text-xl sm:leading-7 md:text-2xl md:leading-[33px] lg:text-lg lg:leading-6 xl:text-xl xl:leading-7 2xl:text-2xl 2xl:leading-[33px] 3xl:text-3xl 3xl:leading-[40px]">
        {trans("impactMessage1")}
      </p>
      <p className="text-lg font-bold leading-relaxed text-marine sm:text-xl sm:leading-7 md:text-2xl md:leading-[33px] lg:text-lg lg:leading-6 xl:text-xl xl:leading-7 2xl:text-2xl 2xl:leading-[33px] 3xl:text-3xl 3xl:leading-[40px]">
        {trans("impactMessage2")}
      </p>
      <p className="text-lg font-bold leading-relaxed text-marine sm:text-xl sm:leading-7 md:text-2xl md:leading-[33px] lg:text-lg lg:leading-6 xl:text-xl xl:leading-7 2xl:text-2xl 2xl:leading-[33px] 3xl:text-3xl 3xl:leading-[40px]">
        {trans("impactMessage3")}
      </p>
    </div>
  );
}
